
import React from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

const ChippingScoreButtons: React.FC<{ onScoreChange: (score: number) => void }> = ({ onScoreChange }) => {
  const { t } = useTranslation('training');

  return (
    <div className="grid grid-cols-1 gap-2">
      <Button
        className="h-14 bg-green-600 hover:bg-green-700 w-full text-base font-bold text-white"
        onClick={() => onScoreChange(6)}
      >
        {t('level1.scoring.chipping.ballIn')} (6 pts)
      </Button>
      <Button
        className="h-14 bg-green-500 hover:bg-green-600 w-full text-base font-bold text-white"
        onClick={() => onScoreChange(4)}
      >
        {t('level1.scoring.chipping.safeZone06')} (4 pts)
      </Button>
      <Button
        className="h-14 bg-green-400 hover:bg-green-500 w-full text-base font-bold text-white"
        onClick={() => onScoreChange(3)}
      >
        {t('level1.scoring.chipping.at1m')} (3 pts)
      </Button>
      <Button
        className="h-14 bg-yellow-500 hover:bg-yellow-600 w-full text-base font-bold text-white"
        onClick={() => onScoreChange(2)}
      >
        {t('level1.scoring.chipping.at2m')} (2 pts)
      </Button>
      <Button
        className="h-14 bg-yellow-600 hover:bg-yellow-700 w-full text-base font-bold text-white"
        onClick={() => onScoreChange(1)}
      >
        {t('level1.scoring.chipping.at3m')} (1 pt)
      </Button>
      <Button
        className="h-14 bg-red-500 hover:bg-red-600 w-full text-base font-bold text-white"
        onClick={() => onScoreChange(0)}
      >
        {t('level1.scoring.chipping.outsideCircles')} (0 pt)
      </Button>
    </div>
  );
};

export default ChippingScoreButtons;
